/**
 * lm-banner: produktpunkter («Shop the look»).
 * Desktop: kortet åpnes ved hover (CSS). Trykk/klikk veksler kortet
 * (mobil og tastatur). Klikk utenfor eller Escape lukker alle.
 * Lastes av flere seksjoner; lytterne registreres bare én gang.
 */
(function () {
  'use strict';
  if (window.__lmBannerHotspots) return;
  window.__lmBannerHotspots = true;

  function closeAll(except) {
    document.querySelectorAll('[data-lmb-hotspot].is-open').forEach(function (hs) {
      if (hs === except) return;
      hs.classList.remove('is-open');
      var dot = hs.querySelector('.lmb__hs-dot');
      if (dot) dot.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var dot = event.target.closest('.lmb__hs-dot');
    if (dot) {
      event.preventDefault();
      event.stopPropagation();
      var hs = dot.closest('[data-lmb-hotspot]');
      var open = !hs.classList.contains('is-open');
      closeAll(hs);
      hs.classList.toggle('is-open', open);
      dot.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (!event.target.closest('.lmb__hs-card')) closeAll();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });
})();
